module.exports = __webpack_public_path__ + "static/media/whatsap-icon.ee1b99af.svg";